import {
  Container,
  InputCheckbox,
  InputRadio,
  InputToggle,
  Notifications,
  Text,
  Tooltip,
  Selectors,
  InputField,
  ActionButton,
  Spinner,
  Icon,
  Button,
} from "@jds/core";
import React, { useCallback, useEffect, useRef, useState } from "react";
import useApiHttp from "../hooks/use-http";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import {
  Box,
  Card,
  FormControlLabel,
  Paper,
  Stack,
  Switch,
} from "@mui/material";
import JdsModal from "../components/UI/JdsModal";
import "./SettingsPage.css";
import useInput from "../hooks/use-input";
import { validateNumberInput } from "../util/validation";
import { useSelector } from "react-redux";
import CreateWatermark from "../components/UI/Form/CreateWatermark";

export default function SettingsPage() {
  const { id: eventId } = useParams();
  const navigate = useNavigate();
  // const { eventDetails } = useSelector((state) => state.eventDetails);
  const [eventDetails, setEventDetails] = useState();
  const [isAutoApproval, setIsAutoApproval] = useState();
  const [defaultAccess, setDefaultAccess] = useState();
  const [defaultDownloadAccess, setDefaultDownloadAccess] = useState();
  const [defaultUploadAccess, setDefaultUploadAccess] = useState();
  const [isAutoApprovalModalClose, setIsAutoApprovalModalClose] =
    useState(true);
  const [isOpenEvent, setIsOpenEvent] = useState(true);
  const [isImageAccessModalClose, setImageAccessModalClose] = useState(true);
  const [folderList, setFolderList] = useState([]);
  const [page, setPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const loginDetails = useSelector((state) => state.auth.loginDetails);
  const isJitoUser = loginDetails?.userType === "JITO";

  const [isWatermarkModalClose, setWatermarkModalClose] = useState(true);
  const [watermarkData, setWatermarkData] = useState(null);

  const {
    value: preCost,
    isValid: preCostIsValid,
    hasError: preCostHasError,
    valueChangeHandler: preCostChangeHandler,
    inputBlurHandler: preCostBlurHandler,
    reset: resetPreCostInput,
  } = useInput(validateNumberInput, {
    type: "text",
    value: eventDetails?.premiumImageCost,
  });
  const { sendRequest: getEventDetails, isLoading: eventDetailsLoading } =
    useApiHttp();
  const {
    sendRequest: giveDefaultAccessApi,
    isLoading: isDefaultAccessLoading,
  } = useApiHttp();
  const {
    sendRequest: giveDefaultUploadAccessApi,
    isLoading: isDefaultUploadAccessLoading,
  } = useApiHttp();
  const {
    sendRequest: giveDefaultDownloadAccessApi,
    isLoading: isDefaultDownloadAccessLoading,
  } = useApiHttp();
  const { sendRequest: makeEventPublicApi, isLoading: isAutoApprovalLoading } =
    useApiHttp();
  const {
    sendRequest: updatePremiumCostApi,
    isLoading: isPremiumCostUpdateing,
  } = useApiHttp();
  const { sendRequest: getFoldersReq, isLoading: isFolGeting } = useApiHttp();
  const { sendRequest: folderPremiumReq, isLoading: isPremiumRequesting } =
    useApiHttp();

  const {
    sendRequest: getWateramrkDetails,
    isLoading: isWatermarkDetailsLoading,
  } = useApiHttp();

  const imageAccessClickHandler = (val) => {
    setDefaultAccess(val);
    // setImageAccessModalClose(false);
    giveDefaultAccessApi(
      {
        url: "event/switch-default-access",
        method: "PATCH",
        body: {
          id: eventId,
          defaultAccess: val,
        },
      },
      (data) => { },
      (data) => {
        // setIsAutoApprovalModalClose(true);
        Notifications.toast.success({
          id: "switch-approval",
          title: data?.message,
        });
      }
    );
  };
  const hadlePremiumCost = () => {
    preCostBlurHandler(preCost);
    if (preCostIsValid) {
      const formData = new FormData();
      formData.append("id", eventId);
      formData.append("premiumImageCost", preCost);
      updatePremiumCostApi(
        {
          url: "event/update-premium-image-cost",
          method: "PATCH",
          body: formData,
          formData: true,
        },
        (data) => { },
        (data) => {
          Notifications.toast.success({
            id: "switch-approval",
            title: data?.message,
          });
        }
      );
    }
  };
  const getFoldersHandler = () => {
    getFoldersReq(
      {
        url: `event-folders/get-event-folder/${eventId}?page=${page}&size=50`,
      },
      null,
      (data) => {
        if (page == 0) {
          setFolderList(data.data.results);
          setLastPage(data?.data.lastPage);
        } else {
          setFolderList((pre) => [...pre, ...data.data.results]);
          setLastPage(data?.data.lastPage);
        }
      },
      (err, data) => {
        Notifications.toast.error({
          id: "get-folder",
          title: data?.message,
        });
      }
    );
  };
  const folderPremiumHandler = (id, isPremium) => {
    folderPremiumReq(
      {
        url: "event-folders/switch-premium",
        method: "PATCH",
        body: {
          id: id,
          isPremium: isPremium,
        },
      },
      (data) => { },
      (data) => {
        Notifications.toast.success({
          id: "premium-hadle",
          title: data?.message,
        });
      }
    );
  };

  const getWatermarkRequestHandler = () => {
    getWateramrkDetails(
      {
        url: `watermark/get-event-watermark/${eventId}`,
      },
      null,
      (data) => {
        setWatermarkData(data?.data)
      },
      (_) => { }
    );
  };

  const observerRef = useRef(null);
  const lastElementRef = useCallback(
    (node) => {
      if (isFolGeting) return;
      if (observerRef.current) observerRef.current.disconnect();
      observerRef.current = new IntersectionObserver((element) => {
        if (element[0].isIntersecting && lastPage > page) {
          setPage((pre) => pre + 1);
        }
      });
      if (node) observerRef.current.observe(node);
    },
    [isFolGeting, lastPage]
  );

  useEffect(() => {
    // getFoldersHandler();
    getEventDetails(
      {
        url: `event/get-event/${eventId}`,
        method: "GET",
      },
      null,
      (data) => {
        setEventDetails(data?.data);
        setIsAutoApproval(data?.data?.isAutoApproval);
        setDefaultAccess(data?.data?.defaultAccess);
        setDefaultDownloadAccess(data?.data?.defaultDownloadAccess);
        setDefaultUploadAccess(data?.data?.defaultUploadAccess);
      }
    );
  }, [page]);

  useEffect(() => {
    getWatermarkRequestHandler();
  }, []);


  if (eventDetailsLoading || (isFolGeting && page == 0)) {
    return (
      <Container
        fullWidth
        horizontalAlign="center"
        verticalAlign="center"
        style={{ minHeight: "220px" }}
      >
        <Spinner kind="primary" label="Loading..." size="large" />
      </Container>
    );
  }

  return (
    <Box>
      <Box mb={4}>
        <Text text="Settings" appearance="heading_s" />
      </Box>

      {/*
      <Text text="Photos access" appearance="body-s-bold" />
      <Container direction="column" gap={32} style={{ marginTop: "12px" }}>
        <Container gap={24}>
          <InputRadio
            checked={defaultAccess === "FACE_ACCESS"}
            label="Face Access"
            value="FACE_ACCESS"
            onClick={(e) => imageAccessClickHandler(e.target.value)}
            size="medium"
          />
          <InputRadio
            checked={defaultAccess === "FULL_ACCESS"}
            label="Full Access"
            value="FULL_ACCESS"
            onClick={(e) => imageAccessClickHandler(e.target.value)}
            size="medium"
          />
          <InputCheckbox
            checked={defaultDownloadAccess === "APPROVED"}
            size="medium"
            label="Download Access"
            onChange={(e) => {
              const checked = e.target.checked;
              const defaultDownloadAccess = checked ? "APPROVED" : "REJECTED";
              setDefaultDownloadAccess(defaultDownloadAccess);
              giveDefaultDownloadAccessApi(
                {
                  url: "event/switch-default-download-access",
                  method: "PATCH",
                  body: {
                    id: eventId,
                    defaultDownloadAccess,
                  },
                },
                (data) => {},
                (data) => {
                  // setIsAutoApprovalModalClose(true);
                  Notifications.toast.success({
                    id: "switch-approval",
                    title: data?.message,
                  });
                }
              );
            }}
          />
        </Container> */}
      {/* <Text text="Event type" appearance="body-s-bold" />
        <Container direction="column" gap={0} style={{ marginTop: "-30px" }}> */}
      {/* <Text
            appearance="heading-xxs"
            text="Auto Approval"
            color="primary-grey-80"
          /> */}
      {/* <Tooltip
            label={
              <Text
                text="This will allow guests to be approved automatically."
                color="white"
              />
            }
          >
            <FormControlLabel
              checked={isAutoApproval}
              control={<Switch />}
              label={<Text text="Public Event" color="primary_grey_80" />}
              labelPlacement="start"
              onChange={() => {
                setIsAutoApprovalModalClose(false);
                makeEventPublicApi(
                  {
                    url: "event/switch-auto-approval",
                    method: "PATCH",
                    body: {
                      id: eventId,
                      isAutoApproval: !isAutoApproval,
                    },
                  },
                  (data) => {},
                  (data) => {
                    setIsAutoApprovalModalClose(true);
                    Notifications.toast.success({
                      id: "switch-approval",
                      title: data?.message,
                    });
                    setIsAutoApproval((prev) => !prev);
                  }
                );
              }}
              sx={{ marginLeft: 0 }}
            />
          </Tooltip>
        </Container>
      </Container> */}
      <Box className="sub-settings__card" mb={4}>
        <Box mb={3}>
          <div className="text-container">
            <Text text="Event" appearance="heading_xs" />
            <Text
              appearance="body_s"
              color="primary_grey_80"
              text="These changes will impact all the users of this event."
            />
          </div>
        </Box>
        {/* Photos access */}
        <Box sx={{ borderBottom: "1px solid #E8E8FC", padding: "15px 0" }}>
          <div className="box-container">
            <div className="text-container">
              <Text text="Photos Access" appearance="body_m_bold" />
              <Text
                text={
                  defaultAccess === "FULL_ACCESS"
                    ? "Guests can view all photos from the Event."
                    : "Guests can view their photos from the Event."
                }
                appearance="body_xs_bold"
                color="primary_grey_60"
              />
            </div>
            <div className="access-selectors">
              <Selectors
                stretch={true}
                selectedIndex={defaultAccess === "FULL_ACCESS" ? 1 : 0}
                items={[
                  { label: "Face Access", value: "FACE_ACCESS" },
                  { label: "Full Access", value: "FULL_ACCESS" },
                ]}
                onChange={(value) => imageAccessClickHandler(value)}
              />
            </div>
          </div>
        </Box>
        {/* Upload access */}
        <Box sx={{ borderBottom: "1px solid #E8E8FC", padding: "15px 0" }}>
          <div className="box-container">
            <div className="text-container">
              <Text text="Upload Access" appearance="body_m_bold" />
              <Text
                text={
                  defaultUploadAccess === "APPROVED"
                    ? "All guests can upload event photos."
                    : "You can choose which guests can upload the photos."
                }
                appearance="body_xs_bold"
                color="primary_grey_60"
              />
            </div>
            <div className="access-selectors">
              <Selectors
                stretch={true}
                selectedIndex={defaultUploadAccess === "APPROVED" ? 0 : 1}
                items={[
                  { label: "Yes", value: "APPROVED" },
                  { label: "No", value: "NULL" },
                ]}
                onChange={(value) => {
                  setDefaultUploadAccess(value);
                  giveDefaultUploadAccessApi(
                    {
                      url: "event/switch-default-upload-access",
                      method: "PATCH",
                      body: {
                        id: eventId,
                        defaultUploadAccess: value,
                      },
                    },
                    (data) => { },
                    (data) => {
                      // setIsAutoApprovalModalClose(true);
                      Notifications.toast.success({
                        id: "switch-upload-access",
                        title: data?.message,
                      });
                    }
                  );
                }}
              />
            </div>
          </div>
        </Box>
        {/* Download access */}
        <Box sx={{ borderBottom: "1px solid #E8E8FC", padding: "15px 0" }}>
          <div className="box-container">
            <div className="text-container">
              <Text text="Download Access" appearance="body_m_bold" />
              <Text
                text={
                  defaultDownloadAccess === "APPROVED"
                    ? "All guests can download event photos."
                    : "You can choose which guests can download the photos."
                }
                appearance="body_xs_bold"
                color="primary_grey_60"
              />
            </div>
            <div className="access-selectors">
              <Selectors
                stretch={true}
                selectedIndex={defaultDownloadAccess === "APPROVED" ? 0 : 1}
                items={[
                  { label: "Yes", value: "APPROVED" },
                  { label: "No", value: "NULL" },
                ]}
                onChange={(value) => {
                  setDefaultDownloadAccess(value);
                  giveDefaultDownloadAccessApi(
                    {
                      url: "event/switch-default-download-access",
                      method: "PATCH",
                      body: {
                        id: eventId,
                        defaultDownloadAccess: value,
                      },
                    },
                    (data) => { },
                    (data) => {
                      // setIsAutoApprovalModalClose(true);
                      Notifications.toast.success({
                        id: "switch-approval",
                        title: data?.message,
                      });
                    }
                  );
                }}
              />
            </div>
          </div>
        </Box>
        {/* Event type */}
        <Box sx={{ borderBottom: "1px solid #E8E8FC", padding: "15px 0" }}>
          <div className="box-container">
            <div className="text-container">
              <Text text="Event type" appearance="body_m_bold" />
              <Text
                text={
                  isOpenEvent
                    ? "Guests scanning the QR code can join the event automatically."
                    : "Guests scanning the QR code need your approval to join the event."
                }
                appearance="body_xs_bold"
                color="primary_grey_60"
              />
            </div>
            <div className="access-selectors">
              <Selectors
                stretch={true}
                selectedIndex={isAutoApproval ? 0 : 1}
                items={[
                  { label: "Public", value: "0" },
                  { label: "Private", value: "1" },
                ]}
                onChange={(value) => {
                  setIsAutoApprovalModalClose(value);
                  makeEventPublicApi(
                    {
                      url: "event/switch-auto-approval",
                      method: "PATCH",
                      body: {
                        id: eventId,
                        isAutoApproval: value === "0" ? true : false,
                      },
                    },
                    (data) => { },
                    (data) => {
                      setIsAutoApprovalModalClose(value);
                      Notifications.toast.success({
                        id: "switch-approval",
                        title: data?.message,
                      });
                      // setIsAutoApproval((prev) => !prev);
                      setIsOpenEvent(value === "0" ? true : false);
                    }
                  );
                }}
                sx={{ marginLeft: 0 }}
              />
            </div>
          </div>
        </Box>
        {/* Watermark */}
        <Box sx={{ padding: "15px 0" }}>
          <div className="box-container">
            <div className="text-container">
              <Text text="Watermark" appearance="body_m_bold" />
              <Text
                text={
                  "Watermark will be applied to all photos across all folders of this event."
                }
                appearance="body_xs_bold"
                color="primary_grey_60"
              />
            </div>
            <Box width={180}>
              <Button label={watermarkData ? "Update" : "Add"} size="medium" fullWidth onClick={() => setWatermarkModalClose(false)} />
            </Box>
          </div>
        </Box>
      </Box>
      {/* <Box className="sub-settings__card" mb={4}>
        <Box mb={3}>
          <div className="text-container">
            <Text text="Album" appearance="heading_xs" />
          </div>
        </Box>
        <Box sx={{ padding: "0" }}>
          <div
            className="sub-setting__menu"
            onClick={() => navigate(`premium-image-cost`)}
          >
            <Text text="Premium Image Plans" appearance="body_m_bold" />
            <Icon ic={"IcNext"} size="large" />
          </div>
          <div
            className="sub-setting__menu"
            onClick={() => navigate(`premium-albums`)}
          >
            <Text text="Premium Albums" appearance="body_m_bold" />
            <Icon ic={"IcNext"} size="large" />
          </div>
        </Box>
      </Box>
      {/* <Box className="sub-settings__card">
        <Box mb={2}>
          <Text text="Payment" appearance="heading_xs" />
        </Box>
        <div
          className="sub-setting__menu"
          onClick={() => navigate(`order-history`)}
        >
          <Text text="Order History" appearance="body_m_bold" />
          <Icon ic={"IcNext"} size="large" />
        </div>
      </Box> */}


      <JdsModal
        header="Add Watermark"
        close={isWatermarkModalClose}
        onClose={() => {
          setWatermarkModalClose(true);
        }}
      >
        {!isWatermarkModalClose && (
          <CreateWatermark onSuccess={() => getWatermarkRequestHandler()} onCancel={() => setWatermarkModalClose(true)} onDelete={() => setWatermarkData(null)} />
        )}
      </JdsModal>
    </Box>
  );
}
